import { LoginPanel } from './LoginPanel'

export const Login = () => {
  return (
    <div suppressHydrationWarning={true} className="h100">
      <LoginPanel />
    </div>
  )
}
